import React, { useRef } from "react";

export const useId = (prefix = "sc") => {
  const ref = useRef(null);
  if (!ref.current)
    ref.current = `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
  return ref.current;
};
